/**
 * Created by Greg on 4/26/2016.
 */
import jjv from 'jjv';
import * as pathSchema from './pathSchema.json';


/**
 * Path validator checks for valid JSON, schema compliance. We do not check
 * for compatibility of the path with the current network. See the *pathValidate*
 * function for that functionality.
 *
 * @param pathString The JSON string of paths to validate
 * @returns {boolean}
 */
function pathCollectionValidate(pathString) {
    let pathObj = null,
        errors = null;
    try {
        pathObj = JSON.parse(pathString);
    } catch (e) {
        errors = "Invalid JSON string: " + e;
    }
    if (pathObj) {
        let env = jjv();
        env.checkRequired = true;
        errors = env.validate(pathSchema, pathObj);
    }
    return {errors: errors, pathObj: pathObj};
}

/*  For reliability studies it is useful to know if a path is invalid due to
    nodes, links, or both. The path is an object that must contain a nodeList
    all other properties are ignored.
 */
function pathValidate(path, net) {
    let links = net.links;
    let nodes = net.nodes;
    let nodeList = path.nodeList;
    let valid = true;
    // Check nodes
    let missingNodes = [];
    for (let node of nodeList) {
        if(!nodes.find(n => n.id === node)) {
            missingNodes.push(node);
            valid = false;
        }
    }
    // Check links
    let missingLinks = [];
    for (let j = 0; j < nodeList.length - 1; j++) {
        let linkFwd = links.find(function (l) {
            return l.source === nodeList[j] && l.target === nodeList[j + 1];
        });
        let linkBwd = links.find(function (l) {
            return l.source === nodeList[j + 1] && l.target === nodeList[j];
        });
        if (!(linkFwd || linkBwd)) {
            missingLinks.push(nodeList[j] + "-" + nodeList[j + 1]);
            valid = false;
        }
    }
    return {valid: valid, missingNodes: missingNodes, missingLinks: missingLinks};
}

export {pathCollectionValidate, pathValidate};


// WEBPACK FOOTER //
// ./validation/pathValid.js